import swiper from "swiper";

$('.top-recommend-categores-slider').each(function(i, v){
  var $that = $(this);

var categoresMain = new swiper($that.find(".js-categores-main-slider"), {
  direction: "horizontal",
  loop: false,
  effect: "fade",
  spaceBetween: 0,
  speed: 1000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  observer: true,
  allowTouchMove: true,
  preloadImages: false,
  autoHeight: false,
  slidesPerView: 1,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2
  },
  breakpoints: {
    // 960: {
    //   slidesPerView: 2
    // },
    // 414: {
    //   slidesPerView: 1.2
    // }
  }
});

var categoresNav = new swiper($that.find(".js-categores-nav-slider"), {
  direction: "horizontal",
  loop: false,
  spaceBetween: 0,
  observer: true,
  allowTouchMove: false,
  preloadImages: false,
  autoHeight: true,
  slidesPerView: 'auto',
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2
  },
  breakpoints: {
    // 960: {
    //   slidesPerView: 2
    // },
    // 414: {
    //   slidesPerView: 1.2
    // }
  }
});

categoresMain.on('slideChange', function() {
  $that.find(".js-categores-nav-slider .swiper-slide").removeClass("is-current");
  $that.find(".js-categores-nav-slider .swiper-slide").eq(categoresMain.realIndex).addClass("is-current");
});

$that.find('.js-categores-nav-slider .swiper-slide').on('click', function() {
  var index = categoresNav.clickedIndex;
  categoresMain.slideTo(index);
});

})